import { Asset, useRouter, useTags } from "@tanstack/react-router";

/**
 * The route-managed head tags for a template's example page, without the client app's module
 * preload: the page runs no client app, so neither onboarding's frames nor a demo host fetch it.
 * Its stylesheets stay. In development they are one link to Start's collected component styles
 * (the Tip box, Supporters, forms), which no client app is there to inject instead.
 */
export function TemplatePreviewHeadContent() {
  const tags = useTags();
  const nonce = useRouter().options.ssr?.nonce;
  return tags
    .filter((tag) => tag.tag !== "link" || tag.attrs?.rel !== "modulepreload")
    .map((tag) => <Asset {...tag} key={`tsr-meta-${JSON.stringify(tag)}`} nonce={nonce} />);
}
